module.exports = __webpack_public_path__ + "img/triangleruler.68c4132f.png";